import api from '../index'

const userService = {
    // List all items
    getUsers: async (params) => {
        try {
            const res = await api.get('/api/v1/admin/users', { params })
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch items'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },
}

export default userService
